import React from 'react';
import { MdDarkMode, MdLanguage, MdLightMode, MdOutlineComputer } from 'react-icons/md';
import { usePreferences } from '../../contexts/PreferencesContext';

const PreferenceControls = ({ compact = false }) => {
    const {
        language,
        setLanguage,
        setThemePreference,
        t,
        themePreference,
    } = usePreferences();

    const ThemeIcon = themePreference === 'system'
        ? MdOutlineComputer
        : themePreference === 'dark'
            ? MdDarkMode
            : MdLightMode;

    return (
        <div className={`preference-controls ${compact ? 'compact' : ''}`}>
            <label className="preference-select">
                <span>
                    <ThemeIcon />
                    {!compact && t('theme')}
                </span>
                <select
                    aria-label={t('theme')}
                    value={themePreference}
                    onChange={(event) => setThemePreference(event.target.value)}
                >
                    <option value="system">{t('system')}</option>
                    <option value="light">{t('light')}</option>
                    <option value="dark">{t('dark')}</option>
                </select>
            </label>

            <label className="preference-select">
                <span>
                    <MdLanguage />
                    {!compact && t('language')}
                </span>
                <select
                    aria-label={t('language')}
                    value={language}
                    onChange={(event) => setLanguage(event.target.value)}
                >
                    <option value="pt">{t('portuguese')}</option>
                    <option value="en">{t('english')}</option>
                    <option value="es">{t('spanish')}</option>
                </select>
            </label>
        </div>
    );
};

export default PreferenceControls;
